import * as MutationTypes from './mutationTypes';
import { MenuInitialRecommendation } from './models';
import * as api from './api';

export const recommendationListRequest = async ({
  commit,
  getters: { menuInitialRecommendationList }
}, pointOfSaleGuid) => {
  if (menuInitialRecommendationList.length === 0) {
    const response = await api.recommendationListRequest(pointOfSaleGuid);
    const recommendationList = MenuInitialRecommendation.toInstanceList(response.data);
    commit(MutationTypes.INITIAL_RECOMMENDATION_LIST_SUCCESS, recommendationList);
  }
};

export const deleteRecommendation = async ({ commit }, recommendation) => {
  await api.deleteRecommendationRequest(recommendation.guid);
  commit(MutationTypes.DELETE_INITIAL_RECOMMENDATION_SUCCESS, recommendation);
  return recommendation;
};

export const createRecommendation = async ({ commit }, recommendation) => {
  const response = await api.createRecommendationRequest(recommendation.getFormData());
  // Check 409
  const newRecommendation = MenuInitialRecommendation.toInstance(response.data);
  commit(MutationTypes.CREATE_INITIAL_RECOMMENDATION_SUCCESS, newRecommendation);
  return newRecommendation;
};

export const editRecommendation = async ({ commit }, recommendation) => {
  const response = await api.editRecommendationRequest(recommendation.guid, recommendation.getFormData());
  // Check 409
  const editedRecommendation = MenuInitialRecommendation.toInstance(response.data);
  commit(MutationTypes.EDIT_INITIAL_RECOMMENDATION_SUCCESS, editedRecommendation);
  return recommendation;
};
